import { render } from "./base-input.vue?vue&type=template&id=07af5105&scoped=true&ts=true"
import script from "./base-input.vue?vue&type=script&lang=ts"
export * from "./base-input.vue?vue&type=script&lang=ts"

import "./base-input.vue?vue&type=style&index=0&id=07af5105&lang=scss&scoped=true"

import exportComponent from "E:\\Build\\vsts-agent-win-x64-4.268.0\\_work\\1\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07af5105"]])

export default __exports__